import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const personalAccessToken = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z
      .string()
      .describe('Name - User-supplied label, e.g. "Claude Code on my laptop"'),

    hash: z
      .string()
      .hidden()
      .describe(
        'Hash - SHA-256 hex digest of the token; the plaintext is never stored',
      ),

    displayPrefix: z
      .string()
      .describe(
        'Display Prefix - Redacted form shown in lists, e.g. "adp_…f3a9"',
      ),

    created: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('Created - When the token was minted'),

    expiresAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe(
        'Expires At - Optional expiry; unset means the token does not expire',
      ),

    lastUsedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe(
        'Last Used At - Last successful authentication (stamped at most every few minutes)',
      ),

    revoked: z
      .boolean()
      .nullable()
      .optional()
      .describe(
        'Revoked - Revoked tokens are kept for the audit trail but no longer authenticate',
      ),

    userId: z.number().hidden().describe('Foreign key to User'),

    user: belongsTo('User'),
  })
  .describe(
    "A long-lived bearer credential a user mints for non-browser clients —\nMCP clients (Claude Code, Cursor), CI, scripts. Only a SHA-256 hash of\nthe token is stored; the plaintext is shown exactly once at mint time.\nA token authenticates as the minting user with that user's roles, so it\ncan never do more than the user who minted it.\n\nNo CRUD is exposed over the API — all access goes through the `mint`,\n`mine`, and `revoke` behaviors, which scope every operation to the\ncurrent user.",
  )
  .as('PersonalAccessToken');

export { personalAccessToken as personalAccessTokenSchema };
